import React, { useContext } from "react";
import { UserContext } from "../App";
import { auth, provider } from "../firebase/firebase";

import { signInWithPopup } from "firebase/auth";
import { Link } from "react-router-dom";

const Home = () => {
  const { user, setUser } = useContext(UserContext);
  const signIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      console.log(result);
      const userName = result.user.displayName;
      const email = result.user.email;
      const photoURL = result.user.photoURL;
      const token = await result.user.getIdToken();
      setUser({ userName, email, photoURL });
      localStorage.setItem("self_care_token", token);
      // await axios.post("/api/user/createuser", {token});
      console.log(token);
      // navigate("/dashboard");
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <section className="relative">
        {/* <div
          className="absolute bottom-0 transform -translate-x-1/2 pointer-events-none left-1/2"
          aria-hidden="true"
        >
          <svg
            width="1360"
            height="578"
            viewBox="0 0 1360 578"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                x1="50%"
                y1="0%"
                x2="50%"
                y2="100%"
                id="illustration-01"
              >
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#EAEAEA" offset="77.402%" />
                <stop stopColor="#DFDFDF" offset="100%" />
              </linearGradient>
            </defs>
            <g fill="url(#illustration-01)" fillRule="evenodd">
              <circle cx="1232" cy="128" r="128" />
              <circle cx="155" cy="443" r="64">
                <svg
                  width="1000"
                  height="1000"
                  viewBox="0 0 1000 1000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="url(#illustration-01)" fillRule="evenodd">
                    <path d="M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z" />
                  </g>
                </svg>
              </circle>
            </g>
          </svg>
        </div> */}
        <div className="max-w-6xl px-4 mx-auto sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20">
            <div className="pb-12 text-center md:pb-16">
              <h1
                className="mb-4 text-5xl font-extrabold tracking-tighter md:text-6xl leading-tighter"
                data-aos="zoom-y-out"
              >
                Make your meals{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">
                  Yummy
                </span>
              </h1>
              <div className="max-w-3xl mx-auto">
                <p
                  className="mb-8 text-xl text-gray-600"
                  data-aos="zoom-y-out"
                  data-aos-delay="150"
                >
                  {user.userName && (
                    <div>
                      Welcome <b> {user.userName}</b>
                    </div>
                  )}
                </p>
              </div>
            </div>

            {/* Hero image */}
            {/* hide following div user.userName exists */}

            <div className={`${user.userName ? "hidden" : ""}`}>
              <div
                className="relative flex justify-center mb-8"
                data-aos="zoom-y-out"
                data-aos-delay="450"
              >
                <div className="flex flex-col justify-center">
                  {/* <img className="mx-auto" src={HeroImage} width="768" height="432" alt="Hero" /> */}
                  <svg
                    className="absolute inset-0 h-auto max-w-full mx-auto md:max-w-none"
                    width="768"
                    height="432"
                    viewBox="0 0 768 432"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <defs>
                      <linearGradient
                        x1="50%"
                        y1="0%"
                        x2="50%"
                        y2="100%"
                        id="hero-ill-a"
                      >
                        <stop stopColor="#FFF" offset="0%" />
                        <stop stopColor="#EAEAEA" offset="77.402%" />
                        <stop stopColor="#DFDFDF" offset="100%" />
                      </linearGradient>
                      <linearGradient
                        x1="50%"
                        y1="0%"
                        x2="50%"
                        y2="99.24%"
                        id="hero-ill-b"
                      >
                        <stop stopColor="#FFF" offset="0%" />
                        <stop stopColor="#EAEAEA" offset="48.57%" />
                        <stop
                          stopColor="#DFDFDF"
                          stopOpacity="0"
                          offset="100%"
                        />
                      </linearGradient>
                      <radialGradient
                        cx="21.152%"
                        cy="86.063%"
                        fx="21.152%"
                        fy="86.063%"
                        r="79.941%"
                        id="hero-ill-e"
                      >
                        <stop stopColor="#4FD1C5" offset="0%" />
                        <stop stopColor="#81E6D9" offset="25.871%" />
                        <stop stopColor="#338CF5" offset="100%" />
                      </radialGradient>
                      <circle id="hero-ill-d" cx="384" cy="216" r="64" />
                    </defs>
                    <g fill="none" fillRule="evenodd">
                      <circle
                        fillOpacity=".04"
                        fill="url(#hero-ill-a)"
                        cx="384"
                        cy="216"
                        r="128"
                      />
                      <circle
                        fillOpacity=".16"
                        fill="url(#hero-ill-b)"
                        cx="384"
                        cy="216"
                        r="96"
                      />
                      <g fillRule="nonzero">
                        <use fill="#000" xlinkHref="#hero-ill-d" />
                        <use fill="url(#hero-ill-e)" xlinkHref="#hero-ill-d" />
                      </g>
                    </g>
                  </svg>
                </div>
                <button
                  className="absolute flex items-center p-4 font-medium transform -translate-y-1/2 bg-white rounded-full shadow-lg top-full group hover:bg-yellow-300"
                  onClick={signIn}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="flex-shrink-0 w-6 h-6 text-gray-400 fill-current group-hover:text-black"
                    xmlSpace="preserve"
                    width={200}
                    height={200}
                    viewBox="0 0 60 60"
                  >
                    <path d="M18.35 20.805a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684c.87-.87 1.35-2.026 1.35-3.256s-.479-2.386-1.35-3.256a.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842s-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zM40.35 20.805a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684c.87-.87 1.35-2.026 1.35-3.256s-.479-2.386-1.35-3.256a.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842s-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zM29.35 14.805a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684c.87-.87 1.35-2.026 1.35-3.256s-.479-2.386-1.35-3.256a.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842s-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zM55.624 43.721C53.812 33.08 45.517 24.625 34.957 22.577c.017-.16.043-.321.043-.48 0-2.757-2.243-5-5-5s-5 2.243-5 5c0 .159.025.32.043.48C14.483 24.625 6.188 33.08 4.376 43.721 2.286 44.904 0 46.645 0 48.598c0 5.085 15.512 8.5 30 8.5s30-3.415 30-8.5c0-1.953-2.286-3.694-4.376-4.877zM27.006 22.27A3.004 3.004 0 0 1 30 19.098a3.004 3.004 0 0 1 2.994 3.172c-.047-.005-.094-.007-.14-.012a25.32 25.32 0 0 0-1.038-.089c-.128-.009-.255-.022-.383-.029-.474-.026-.951-.041-1.432-.041s-.958.015-1.432.041c-.128.007-.255.02-.383.029-.348.024-.694.052-1.038.089-.048.005-.095.006-.142.012zm-1.88 4.365a22.17 22.17 0 0 1 4.86-.537H30a1 1 0 0 1 0 2h-.013c-1.496 0-2.982.164-4.421.488a1 1 0 0 1-.44-1.951zm-5.976 2.362a1 1 0 0 1 1.019 1.721c-4.713 2.792-8.147 7.861-9.186 13.56a1 1 0 0 1-1.968-.36c1.143-6.26 4.932-11.838 10.135-14.921zM30 55.098c-17.096 0-28-4.269-28-6.5 0-.383.474-1.227 2.064-2.328-.004.057-.002.113-.006.17-.034.548-.058 1.1-.058 1.658v.788l.767.185c8.254 1.981 16.744 2.985 25.233 2.985s16.979-1.004 25.233-2.985l.767-.185v-.788c0-.558-.024-1.109-.058-1.658-.004-.057-.002-.113-.006-.17C57.526 47.371 58 48.215 58 48.598c0 2.231-10.904 6.5-28 6.5z" />
                  </svg>
                  <span className="ml-3">Try it out!</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* </section> */}
      <section className="relative">
        <div className="max-w-6xl px-4 mx-auto sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20">
            <div className="pb-12 text-center md:pb-16">
              <h1
                className="mb-4 text-4xl font-extrabold tracking-tighter md:text-3xl leading-tighter"
                data-aos="zoom-y-out"
              >
                Features
              </h1>
              <div className="max-w-3xl mx-auto">
                <p
                  className="mb-8 text-xl text-gray-600"
                  data-aos="zoom-y-out"
                  data-aos-delay="150"
                >
                  Description of the app
                </p>
                <div
                  className="max-w-xs mx-auto mb-2 sm:max-w-none sm:flex sm:justify-center"
                  data-aos="zoom-y-out"
                  data-aos-delay="300"
                >
                  <div>
                    <Link
                      className="w-full mb-4 text-white bg-blue-600 btn hover:bg-blue-700 sm:w-auto sm:mb-0"
                      to="/Recipe"
                    >
                      Recipes
                    </Link>
                  </div>
                  <div>
                    <Link
                      className="w-full text-white bg-gray-900 btn hover:bg-gray-800 sm:w-auto sm:ml-4"
                      to="/inventory"
                    >
                      Inventory
                    </Link>
                  </div>
                </div>
                <div
                  className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center"
                  data-aos="zoom-y-out"
                  data-aos-delay="300"
                >
                  <div>
                    <Link
                      className="w-full mb-4 text-white bg-blue-600 btn hover:bg-blue-700 sm:w-auto sm:mb-0"
                      to="/health"
                    >
                      Health
                    </Link>
                  </div>
                  <div>
                    <Link
                      className="w-full text-white bg-gray-900 btn hover:bg-gray-800 sm:w-auto sm:ml-4"
                      to="/goals"
                    >
                      Goals
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
